/**
 * @generated SignedSource<<d3e2f0a8e3310140eb095ac3828cbda4>>
 * @relayHash 71b562495b4516efb20b2a552903aec6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71b562495b4516efb20b2a552903aec6

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MessageRole = "DOCTOR" | "PATIENT";
export type TranslateInput = {
  aiRequestMetadata: AiRequestMetadataInput;
  messageRole: MessageRole;
};
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type deTranslateQuery$variables = {
  input: TranslateInput;
};
export type deTranslateQuery$data = {
  readonly translate: {
    readonly aiAnonymizationRequestDurationMs: number;
    readonly aiRequestDurationMs: number;
    readonly fileHash: string;
    readonly result: AiResult;
    readonly text: string;
  };
};
export type deTranslateQuery = {
  response: deTranslateQuery$data;
  variables: deTranslateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "translate",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TextResult",
    "kind": "LinkedField",
    "name": "de_translate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiRequestDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiAnonymizationRequestDurationMs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deTranslateQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deTranslateQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "71b562495b4516efb20b2a552903aec6",
    "metadata": {},
    "name": "deTranslateQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7bbf46c5c59bbfc94036a2032ae53c6c";

export default node;
